import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useRecoilValue } from "recoil";
import { useAuthActions, useSystemActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import API from "@unisearch/helpers/api";
import { useRouter } from "next/router";
import { Divider, Grid } from "@mui/material";
import {
  getAssets,
  public_url,
  swalError,
  swalMessage,
} from "@unisearch/helpers";
import { Formik } from "formik";
import styles from "./enroll.module.scss";

export const EnrolComponent = () => {
  const router = useRouter();
  const profileInfo = useRecoilValue(authAtom);
  const systemActions = useSystemActions();
  const authActions = useAuthActions();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    systemActions.removeReturnUrl();
  }, []);

  const subjectHTML = `
    <div
      style="
        font-size: 22px;
        font-weight: 600;
        line-height: 36px;
        padding: 0 50px;
        text-align: center;
        margin: 0 !important;"
    >
    Your Registration was Successful! | UniSearch Complete IELTS Training Program
    </div>
`;
  const bodyHTML = (dataTime) => {
    return `
      <div style="padding: 0 50px; font-size: 12px">
        <p style="line-height: 1.8">Dear --NAME--,</p>
        <p style="line-height: 1.8">
        We’re delighted to have you be a part of the UniSearch Complete IELTS Training Program!
        </p>
        <p style="line-height: 1.8">
          Our core mission at UniSearch is to support students every step of the way in their study abroad journey. Since hitting your target IELTS Academic scores is a key part of that journey, this 3-week program is designed to take your English language abilities where they need to be to ace those exams.
        </p>
        <p style="line-height: 1.8">
          ${dataTime}.
        </p>
        <p style="line-height: 1.8">
          Please join the session through the link below:
        </p>
        <p>
          <a
            href="https://zoom.us/j/94960983299?pwd=N093UkVZd0JoMXczbmdhdTl4cWJ6UT09#success"
            target="_blank"
            style="
              padding: 10px 20px;
              display: inline-block;
              text-decoration: none;
              border-radius: 6px;
              background: #f47f20;
              color: white;
              cursor: pointer;
            "
          >
            Join Now
          </a>
        </p>
        <p style="line-height: 1.8">
        For further information, do reach out to us at <br />
        info@myunisearch.com +91 9717814894 +91 78884 13811
        </p>
        <p style="line-height: 1.8">
          See you soon! <br />
          UniSearch
        </p>
      </div>
  `;
  };

  //Initial Information
  const initialValues = {
    title: "UniSearch- IELTS - Student Offerings",
    imageSrc: getAssets("assets/images/elearning/Test-Prep-IELTS-Regular.png"),
    description: "",
    subjectHTML,
    bodyHTML: bodyHTML("We will inform you batch and time schedule later!"),
    batchDetails: {
      name: "Batch",
      startDate: "batch",
      time: "We will inform you time schedule later!",
    },
    subTotal: 1499,
    tax: 0,
    productLink: public_url("elearning/ielts"),
  };

  //Initial Information
  const validate = (values) => {
    let errors = {};
    if (!values.batchDetails.name) {
      errors.batchDetails.name = "Batch is Required";
    }
    return errors;
  };

  const submitForm = async (values) => {
    setLoading(true);
    if (profileInfo && profileInfo.userTypeSlug) {
      await API.post(`/online-learning/purchase`, values).then(async (resp) => {
        if (!resp.error && resp.data) {
          swalMessage(
            "Order Success!",
            "Your order has been successfully done."
          ).then((btnresp) => {
            if (btnresp.isConfirmed) {
              router.push("/app/student/elearning/courses");
            }
          });
          setLoading(false);
        } else {
          swalError(resp.message, "Sorry!").then((btnresp) => {
            if (btnresp.isConfirmed) {
              router.push("/app/student/elearning/courses");
            }
          });
        }
      });
    } else {
      systemActions.setReturnUrl(router.asPath);
      // swalError("You need logged in to confirm this booking", "Sorry!");
      return router.push({ pathname: "/signin" });
      setLoading(false);
    }
  };

  return (
    <section className={styles.section_enroll}>
      <div className="container">
        <Grid container spacing={4} justifyContent="center">
          <Grid item md={8} xs={12}>
            <div className={styles.left_wrapper}>
              <h2 className={styles.left_heading}>Order & Billing Address</h2>
              <Divider />
              <div className={styles.left_sub_heading}>
                <div className={styles.order_image_wrapper}>
                  <img
                    src={getAssets(
                      "assets/images/elearning/Test-Prep-IELTS-Regular.png"
                    )}
                    alt="Order course"
                  />
                </div>
                <div className={styles.left_sub_heading_text}>
                  UniSearch- IELTS - Student Offerings <br />
                  <strong className={styles.price}>Rs 1499/-</strong>
                </div>
              </div>
              <Formik
                initialValues={initialValues}
                validate={validate}
                onSubmit={submitForm}
              >
                {(formik) => {
                  const {
                    values,
                    setFieldValue,
                    handleSubmit,
                    errors,
                    touched,
                    handleBlur,
                    isValid,
                    dirty,
                  } = formik;
                  return (
                    <div className={styles.batches_wrapper}>
                      <form onSubmit={handleSubmit}>
                        {/* <Grid container spacing={{ xs: 2, sm: 2, md: 4 }}>
                          <Grid item md={6} sm={6} xs={12}>
                            <label className={styles.batch} htmlFor="batch8">
                              <input
                                type="radio"
                                id="batch8"
                                checked={
                                  values.batchDetails.name &&
                                  values.batchDetails.name == "Batch-8"
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  setFieldValue("batchDetails", {
                                    name: "Batch-8",
                                    startDate: "14 JUNE 2022",
                                    time: "10:00 AM to 12:00 PM | TUE to FRI",
                                  });
                                  setFieldValue(
                                    "bodyHTML",
                                    bodyHTML(
                                      "Date - 14 JUNE 2022, Time - 10:00 to 12:00 PM, Batch - 08"
                                    )
                                  );
                                }}
                              />
                              <div className={styles.content}>
                                <span className={styles.circle}></span>
                                <div className={styles.content_list}>
                                  <div className={styles.text_highlight}>
                                    Batch-8
                                  </div>
                                  <div className={styles.text_regular}>
                                    14 JUNE 2022
                                  </div>
                                  <div className={styles.text_highlight}>
                                    Time
                                  </div>
                                  <div className={styles.text_regular}>
                                    10:00 AM to 12:00 PM TUE to FRI
                                  </div>
                                </div>
                              </div>
                            </label>
                          </Grid>

                          <Grid item md={6} sm={6} xs={12}>
                            <label className={styles.batch} htmlFor="batch9">
                              <input
                                type="radio"
                                id="batch9"
                                checked={
                                  values.batchDetails.name &&
                                  values.batchDetails.name == "Batch-9"
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  setFieldValue("batchDetails", {
                                    name: "Batch-9",
                                    startDate: "21 JUNE 2022",
                                    time: "05:30 PM to 07:30 PM | TUE to FRI",
                                  });
                                  setFieldValue(
                                    "bodyHTML",
                                    bodyHTML(
                                      "Date - 21 JUNE 2022, Time - 05:30 to 07:30 PM, Batch - 09"
                                    )
                                  );
                                }}
                              />
                              <div className={styles.content}>
                                <span className={styles.circle}></span>
                                <div className={styles.content_list}>
                                  <div className={styles.text_highlight}>
                                    Batch-9
                                  </div>
                                  <div className={styles.text_regular}>
                                    21 JUNE 2022
                                  </div>
                                  <div className={styles.text_highlight}>
                                    Time
                                  </div>
                                  <div className={styles.text_regular}>
                                    05:30 PM to 07:30 PM TUE to FRI
                                  </div>
                                </div>
                              </div>
                            </label>
                          </Grid>

                          <Grid item md={6} sm={6} xs={12}>
                            <label className={styles.batch} htmlFor="batch10">
                              <input
                                type="radio"
                                id="batch10"
                                checked={
                                  values.batchDetails.name &&
                                  values.batchDetails.name == "Batch-10"
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  setFieldValue("batchDetails", {
                                    name: "Batch-10",
                                    startDate: "30 JUNE 2022",
                                    time: "10:00 AM to 12:00 PM | TUE to FRI",
                                  });
                                  setFieldValue(
                                    "bodyHTML",
                                    bodyHTML(
                                      "Date - 30 JUNE 2022, Time - 10:00 to 12:00 PM, Batch - 10"
                                    )
                                  );
                                }}
                              />
                              <div className={styles.content}>
                                <span className={styles.circle}></span>
                                <div className={styles.content_list}>
                                  <div className={styles.text_highlight}>
                                    Batch-10
                                  </div>
                                  <div className={styles.text_regular}>
                                    30 JUNE 2022
                                  </div>
                                  <div className={styles.text_highlight}>
                                    Time
                                  </div>
                                  <div className={styles.text_regular}>
                                    10:00 AM to 12:00 PM TUE to FRI
                                  </div>
                                </div>
                              </div>
                            </label>
                          </Grid>

                          <Grid item md={6} sm={6} xs={12}>
                            <label className={styles.batch} htmlFor="batch11">
                              <input
                                type="radio"
                                id="batch11"
                                checked={
                                  values.batchDetails.name &&
                                  values.batchDetails.name == "Batch-11"
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  setFieldValue("batchDetails", {
                                    name: "Batch-11",
                                    startDate: "12 JULY 2022",
                                    time: "05:30 PM to 07:30 PM | TUE to FRI",
                                  });
                                  setFieldValue(
                                    "bodyHTML",
                                    bodyHTML(
                                      "Date - 12 JULY 2022, Time - 05:30 PM to 07:30 PM, Batch - 11"
                                    )
                                  );
                                }}
                              />
                              <div className={styles.content}>
                                <span className={styles.circle}></span>
                                <div className={styles.content_list}>
                                  <div className={styles.text_highlight}>
                                    Batch-11
                                  </div>
                                  <div className={styles.text_regular}>
                                    12 JULY 2022
                                  </div>
                                  <div className={styles.text_highlight}>
                                    Time
                                  </div>
                                  <div className={styles.text_regular}>
                                    5:30 PM to 07:30 PM TUE to FRI
                                  </div>
                                </div>
                              </div>
                            </label>
                          </Grid>

                          <Grid item md={6} sm={6} xs={12}>
                            <label className={styles.batch} htmlFor="batch12">
                              <input
                                type="radio"
                                id="batch12"
                                checked={
                                  values.batchDetails.name &&
                                  values.batchDetails.name == "Batch-12"
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  setFieldValue("batchDetails", {
                                    name: "Batch-12",
                                    startDate: "19 JULY 2022",
                                    time: "10:00 AM to 12:00 PM | TUE to FRI",
                                  });
                                  setFieldValue(
                                    "bodyHTML",
                                    bodyHTML(
                                      "Date - 19 JULY 2022, Time - 10:00 to 12:00 PM, Batch - 12"
                                    )
                                  );
                                }}
                              />
                              <div className={styles.content}>
                                <span className={styles.circle}></span>
                                <div className={styles.content_list}>
                                  <div className={styles.text_highlight}>
                                    Batch-12
                                  </div>
                                  <div className={styles.text_regular}>
                                    19 JULY 2022
                                  </div>
                                  <div className={styles.text_highlight}>
                                    Time
                                  </div>
                                  <div className={styles.text_regular}>
                                    10:00 AM to 12:00 PM TUE to FRI
                                  </div>
                                </div>
                              </div>
                            </label>
                          </Grid>
                        </Grid> */}
                        <div>
                          {errors.batchDetails &&
                            errors.batchDetails.name &&
                            touched.batchDetails.name && (
                              <span className="error">
                                {errors.batchDetails.name}
                              </span>
                            )}
                        </div>

                        <button
                          type="submit"
                          className={`${styles.confirm_btn} btn btn-secondary btn-xl `}
                        >
                          {loading && (
                            <CircularProgress size="16px" color="inherit" />
                          )}
                          Confirm Booking
                        </button>
                      </form>
                    </div>
                  );
                }}
              </Formik>
            </div>
          </Grid>

          {/* <Grid item md={4} xs={12}>
            <div className={styles.right_wrapper}>
              <h4 className={styles.right_heading}>your Order</h4>
              <h5 className={styles.bill}>Bill Details</h5>
              <div className={styles.subtotal}>
                <h6>Subtotal</h6> <p>₹ 1000.00</p>
              </div>
              <div className={styles.taxes}>
                <h6>Taxes & charges</h6> <p>₹ 1800.00</p>
              </div>
              <div className={styles.total}>
                <h6>Order Total </h6> <p>₹ 11800.00</p>
              </div>
              <button className="btn btn-secondary btn-full btn-xl">
                COMPLETE PURCHASE
              </button>
            </div>
          </Grid> */}
        </Grid>
      </div>
    </section>
  );
};

export default EnrolComponent;
